import React, { useState } from "react";
import QRCode from "react-qr-code";
import "./LoyaltyQR.css";

const LoyaltyQR = ({ userId, userName }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // QR encodes a loyalty URL; scanning will redirect to this URL
  const qrValue = `${process.env.REACT_APP_QR_CODE_URL}/loyalty-restaurant-view/${userId}`;
console.log("QR Value:", qrValue);
  if (loading) return <div>Loading QR Card...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div>
      <div className="qr-card">
        <div className="qr-card-inner">
          <div className="qr-code-wrapper">
            <QRCode
              size={256}
              style={{ height: "auto", maxWidth: "100%", width: "100%" }}
              value={qrValue}
              viewBox="0 0 256 256"
              level="H"
            />
          </div>
          <span className="customer-id">{userName || "Customer Name"}</span>
          <p className="qr-instructions">
            Show this QR code at any participating restaurant to view your
            points and redeem rewards.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoyaltyQR;
